import { ReportsTab } from "src/app/pages/home-reports/home-reports.component";

export enum AnalyticsEvent {

    // ===== TRACKING  =====

    SessionStart = "session_start",
    SessionEnd = "session_end",

    // ===== WORK ORDER =====

    WorkOrderView = "work_order_view",
    WorkOrderClick = "work_order_click",
    WorkOrderCreateClick = "work_order_create_click",
    WorkOrderCreateSuccess = "work_order_create_success",
    WorkOrderCreateFail = "work_order_create_fail",

    // ===== AGENDA =====
    AgendaView = 'agenda_view',
    AgendaAddServiceClick = 'agenda_add_service_click',
    AgendaAddServiceDirect = 'agenda_add_service_direct',
    AgendaAddServiceSuccess = 'agenda_add_service_success',
    AgendaAddServiceFail = 'agenda_add_service_fail',

    // ===== BUDGETS =====
    BudgetView = 'budget_view',
    BudgetCreateClick = 'budget_create_click',
    BudgetSaveClick = 'budget_save_click',
    BudgetSaveSuccess = 'budget_save_success',
    BudgetSaveFail = 'budget_save_fail',
    BudgetSendClick = 'budget_send_click',
    BudgetSendSuccess = 'budget_send_success',
    BudgetSendFail = 'budget_send_fail',
    BudgetResolveClick = 'budget_resolve_click',
    BudgetResolvedSuccess = 'budget_resolved_success',
    BudgetResolvedFail = 'budget_resolved_fail',

    // ===== MY SHOP =====
    MyshopView = 'myshop_view',
    EmployeeCreateClick = 'employee_create_click',
    EmployeeCreateSuccess = 'employee_create_success',
    EmployeeCreateFail = 'employee_create_fail',
    EmployeeEditClick = 'employee_edit_click',
    EmployeeEditSuccess = 'employee_edit_success',
    EmployeeEditFail = 'employee_edit_fail',
    ServiceCreateClick = 'service_create_click',
    ServiceCreateSuccess = 'service_create_success',
    ServiceCreateFail = 'service_create_fail',
    ServiceEditClick = 'service_edit_click',
    ServiceEditSuccess = 'service_edit_success',
    ServiceEditFail = 'service_edit_fail',

    // ===== MARKETPLACE =====
    MarketplaceView = 'marketplace_view',
    MarketplaceSearch = 'marketplace_search',
    MarketplaceProductView = 'marketplace_product_view',
    MarketplacePurchaseConfirmClick = 'marketplace_purchase_confirm_click',
    MarketplacePurchaseSuccess = 'marketplace_purchase_success',
    MarketplacePurchaseFail = 'marketplace_purchase_fail',

    // ===== STOCK =====
    StockView = 'stock_view',
    StockImportCsvClick = 'stock_import_csv_click',
    StockImportCsvSuccess = 'stock_import_csv_success',
    StockImportCsvFail = 'stock_import_csv_fail',
    StockAddManualClick = 'stock_add_manual_click',
    StockAddManualSuccess = 'stock_add_manual_success',
    StockAddManualFail = 'stock_add_manual_fail',
    StockAlertsView = 'stock_alerts_view',
    StockAlertRuleCreateClick = 'stock_alert_rule_create_click',
    StockAlertRuleCreateSuccess = 'stock_alert_rule_create_success',
    StockAlertRuleCreateFail = 'stock_alert_rule_create_fail',
    StockAlertRuleEditClick = 'stock_alert_rule_edit_click',
    StockAlertRuleEditSuccess = 'stock_alert_rule_edit_success',
    StockAlertRuleEditFail = 'stock_alert_rule_edit_fail',

    // ===== ORDERS =====
    OrdersView = 'orders_view',
    // OrderReceiveProductClick = 'order_receive_product_click',
    // OrderReceiveProductSuccess = 'order_receive_product_success',
    // OrderReceiveProductFail = 'order_receive_product_fail',
    OrderAddToWarehouseClick = 'order_add_to_warehouse_click',
    OrderAddToWarehouseSuccess = 'order_add_to_warehouse_success',
    OrderAddToWarehouseFail = 'order_add_to_warehouse_fail',
    OrderReserveForAgendaClick = 'order_reserve_for_agenda_click',
    OrderReserveForAgendaSuccess = 'order_reserve_for_agenda_success',
    OrderReserveForAgendaFail = 'order_reserve_for_agenda_fail',

    // ===== PRICING =====
    PricingView = 'pricing_view',
    PricingRuleAddClick = 'pricing_rule_add_click',
    PricingRuleAddSuccess = 'pricing_rule_add_success',
    PricingRuleAddFail = 'pricing_rule_add_fail',

    // ===== SUPPLIERS =====
    SuppliersView = 'suppliers_view',
    SupplierAddClick = 'supplier_add_click',
    SupplierAddSuccess = 'supplier_add_success',
    SupplierAddFail = 'supplier_add_fail',

    // ===== CUSTOMERS =====
    CustomersView = 'customers_view',
    CustomerCreateClick = 'customer_create_click',
    CustomerCreateSuccess = 'customer_create_success',
    CustomerCreateFail = 'customer_create_fail',

    // ===== VEHICLES =====
    VehiclesView = 'vehicles_view',
    VehicleCreateClick = 'vehicle_create_click',
    VehicleCreateSuccess = 'vehicle_create_success',
    VehicleCreateFail = 'vehicle_create_fail',

    // ===== REPORTS =====
    ReportsView = 'reports_view',
    ReportsTabClick = 'reports_tab_click',

    // ===== SETTINGS =====
    SettingsView = 'settings_view',
    SettingsSectionView = 'settings_section_view'
}

/**
 * Global properties present in almost all events.
 * You can auto-inject them in dispatcher instead of requiring everywhere.
 */
export interface AnalyticsGlobalProps {
    event_id?: string;
    timestamp?: string;
    current_session_id?: string;
    current_user_id?: number | string;
    user_name?: string;
    role?: string;
    workshop_id?: string;
    workshop_country?: string;
    device_type?: string;
    app_version?: string;
    screen_name?: string;

    // optional globals
    source?: string;
    entry_point?: string;
    language?: string;
    timezone?: string;
    group_id?: number | string;
    group_name?: string;
    workshop_name?: string;
}

export enum ViewModeType {
    Calendar = 'calendar',
    Gantt = 'gantt',
    List = 'list',
}

export enum SourceType {
    Button = 'button',
    Navbar = 'navbar',
    CalendarDirect = 'calendar_direct',
}

export enum ResolutionType {
    Accepted = 'accepted',
    Rejected = 'rejected'
}


export enum SettingsSection {
    Schedule = 'schedule',
    Holidays = 'holidays',
    Workstations = 'job-positions',
    Users = 'users',
}

export enum PricingRuleType {
    Percentage = 'percentage',
    Fixed = 'fixed',
}

export enum AlertRuleType {
    Min_stock = 'min_stock',
    Low_rotation = 'low_rotation',
    Expiry = 'expiry',
    Other = 'other'
}


export enum SendChannelType {
    Email = "email"
}

export enum NewOrderType {
    Complete = "complete",
    Quick = "quick"
}


/**
 * Map event -> payload typing
 */
export interface AnalyticsEventPayloadMap {

    session_start: AnalyticsGlobalProps & {}
    session_end: AnalyticsGlobalProps & {}


    // ===== WORK ORDER =====
    work_order_view: AnalyticsGlobalProps & {};

    work_order_click: AnalyticsGlobalProps & {
        orderType: NewOrderType;
    };

    work_order_create_click: AnalyticsGlobalProps & {
        orderType: NewOrderType;
    };

    work_order_create_success: AnalyticsGlobalProps & {
        orderType: NewOrderType;
        protocolOrderId?: string;
    };

    work_order_create_fail: AnalyticsGlobalProps & {
        orderType: NewOrderType;

        error_code: number;
        error_message?: string;
        http_status?: number;

    };


    // ===== AGENDA =====
    agenda_view: AnalyticsGlobalProps & {
        view_mode: ViewModeType;
        date_range: string; // DATE FROM - DATE TO
        filters_used?: string[];
    };

    agenda_add_service_click: AnalyticsGlobalProps & {
        source: SourceType;
        entry_point?: string;
    };

    agenda_add_service_direct: AnalyticsGlobalProps & {
        source: SourceType;
        slot_time: string;  // DATE HOUR
        duration_default?: string; // SLOT TIME FROM START TO END EJ: 30 min
    };

    agenda_add_service_success: AnalyticsGlobalProps & {
        service_id: number;
        service_type: string;
        duration: string;
        price: number;
        appointment_id?: string;
    };

    agenda_add_service_fail: AnalyticsGlobalProps & {
        service_type: number;
        error_code: number;
        appointment_id?: string;
        error_message?: string;
        http_status?: number;
        backend_trace_id?: string;
    };

    // ===== BUDGETS =====
    budget_view: AnalyticsGlobalProps & {
        tab_name?: string;
    };

    budget_create_click: AnalyticsGlobalProps & {
        source: SourceType;  // FROM BUTTON OR NAVBAR SHORTCUT
        customer_id?: string;
        vehicle_id?: string;
    };

    budget_save_click: AnalyticsGlobalProps & {
        budget_id: number;
        items_count?: number; // ITEMS AMOUNT - PRODUCTS + ITEMS + SERVICES
        total_amount?: number; // TOTAL PRICE
    };

    budget_save_success: AnalyticsGlobalProps & {
        budget_id: number;
        items_count?: number; // ITEMS AMOUNT - PRODUCTS + ITEMS + SERVICES
        total_amount?: number; // TOTAL PRICE
    };

    budget_save_fail: AnalyticsGlobalProps & {
        budget_id: number; // THE FIRST FAIL WILL NOT HAVE BUDGET_ID
        error_code: string;
        http_status: number;
        error_message?: string;
    };

    budget_send_click: AnalyticsGlobalProps & {
        budget_id: number;
        send_channel?: SendChannelType; // NOW ONLY MAIL
    };

    budget_send_success: AnalyticsGlobalProps & {
        budget_id: number;
        send_channel?: SendChannelType;
    };

    budget_send_fail: AnalyticsGlobalProps & {
        budget_id: number;
        error_code: string;
        errorMessage: string;
        http_status: number;
        send_channel?: SendChannelType;
    };

    budget_resolve_click: AnalyticsGlobalProps & {
        budget_id: number;
    };

    budget_resolved_success: AnalyticsGlobalProps & {
        budget_id: number;
        resolution: ResolutionType;
        reason?: string;
    };

    budget_resolved_fail: AnalyticsGlobalProps & {
        budget_id: number;
        resolution: ResolutionType;
        error_code: string;
        error_message: string;
        http_status: number;
        reason?: string;
    };

    // ===== MY SHOP =====
    myshop_view: AnalyticsGlobalProps & {
        section?: string;
    };

    employee_create_click: AnalyticsGlobalProps & {
        role_assigned?: string;
        permissions_template?: string;
    };

    employee_create_success: AnalyticsGlobalProps & {
        employee_id: number;
        role_assigned?: string;
        permissions_template?: string;
    };

    employee_create_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        role_assigned?: string; // Role name
    };

    employee_edit_click: AnalyticsGlobalProps & {
        employee_id: number;
        fields_changed_count?: number;
    };

    employee_edit_success: AnalyticsGlobalProps & {
        employee_id: number;
        fields_changed_count?: number;
    };

    employee_edit_fail: AnalyticsGlobalProps & {
        employee_id: number;
        error_code: string;
        error_message: string;
        http_status: number;
    };

    service_create_click: AnalyticsGlobalProps & {
        service_category?: string;
        duration?: string;
        price?: number;
    };

    service_create_success: AnalyticsGlobalProps & {
        service_id: number;
        service_category?: string;
        duration?: string;
        price?: number;
    };

    service_create_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        service_category?: string;
    };

    service_edit_click: AnalyticsGlobalProps & {
        service_id: number;
        fields_changed_count?: number;
    };

    service_edit_success: AnalyticsGlobalProps & {
        service_id: number;
        fields_changed_count?: number;
    };

    service_edit_fail: AnalyticsGlobalProps & {
        service_id: number;
        error_code: string;
        error_message: string;
        http_status: number;
    };

    // ===== MARKETPLACE =====
    marketplace_view: AnalyticsGlobalProps & {};

    marketplace_search: AnalyticsGlobalProps & {
        query: string;
        results_count: number;
        filters_used?: string[];
        category?: string;
    };

    marketplace_product_view: AnalyticsGlobalProps & {
        product_id: number;
        category: string; // Category Name
        brand?: string;
        price?: number;
    };

    marketplace_purchase_confirm_click: AnalyticsGlobalProps & {
        items_count: number;
        cart_value: number;
        contains_tyres?: boolean;
        tyre_size?: string;
        tyre_qty?: number;
        tyre_brand?: string;
    };

    marketplace_purchase_success: AnalyticsGlobalProps & {
        order_id: number;
        items_count: number;
        cart_value: number;
        payment_method?: string;
        contains_tyres?: boolean;
        tyre_size?: string;
        tyre_qty?: number;
        tyre_brand?: string;
    };

    marketplace_purchase_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        items_count: number;
        cart_value: number;
        payment_method?: string;
        contains_tyres?: boolean;
    };

    // ===== STOCK =====
    stock_view: AnalyticsGlobalProps & {
        warehouse_id?: number;
    };

    stock_import_csv_click: AnalyticsGlobalProps & {
        file_rows: number;
        valid_rows: number;
        invalid_rows: number;
        warehouse_id?: number;
    };

    stock_import_csv_success: AnalyticsGlobalProps & {
        file_rows: number;
        valid_rows: number;
        invalid_rows: number;
        warehouse_id?: number;
    };

    stock_import_csv_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        warehouse_id?: number;
    };

    stock_add_manual_click: AnalyticsGlobalProps & {
        warehouse_id?: number;
    };

    stock_add_manual_success: AnalyticsGlobalProps & {
        qty: number;
        product_id?: number;
        price?: number;
        warehouse_id?: number;
    };

    stock_add_manual_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        warehouse_id?: number;
        product_id?: number;
    };

    stock_alerts_view: AnalyticsGlobalProps & {};

    stock_alert_rule_create_click: AnalyticsGlobalProps & {
        rule_type: AlertRuleType;
        threshold?: number;
        scope?: string;
        warehouse_ids?: string;
    };

    stock_alert_rule_create_success: AnalyticsGlobalProps & {
        rule_type: AlertRuleType;
        threshold?: number;
        scope?: string;
        warehouse_ids?: string;
    };

    stock_alert_rule_create_fail: AnalyticsGlobalProps & {
        rule_type: AlertRuleType;
        error_code: string;
        error_message: string;
        http_status: number;
        warehouse_ids?: string;
    };

    stock_alert_rule_edit_click: AnalyticsGlobalProps & {
        rule_type: AlertRuleType;
        threshold?: number;
        scope?: string;
        warehouse_ids?: string;
    };

    stock_alert_rule_edit_success: AnalyticsGlobalProps & {
        rule_type: AlertRuleType;
        threshold?: number;
        scope?: string;
        warehouse_ids?: string;
    };

    stock_alert_rule_edit_fail: AnalyticsGlobalProps & {
        rule_type: AlertRuleType;
        error_code: string;
        error_message: string;
        http_status: number;
        warehouse_id?: string;
    };

    // ===== ORDERS =====
    orders_view: AnalyticsGlobalProps & {
        filter_status?: string;
    };

    // order_receive_product_click: AnalyticsGlobalProps & {
    //     order_id: number;
    // };

    // order_receive_product_success: AnalyticsGlobalProps & {
    //     order_id: number;
    //     items_received_count: number;
    //     partial?: boolean;
    // };

    // order_receive_product_fail: AnalyticsGlobalProps & {
    //     order_id: number;
    //     error_code: string;
    // };

    order_add_to_warehouse_click: AnalyticsGlobalProps & {
        order_id: number;
        warehouse_id?: number;
        items_count?: number;
    };

    order_add_to_warehouse_success: AnalyticsGlobalProps & {
        order_id: number;
        warehouse_id?: number;
        items_count?: number;
    };

    order_add_to_warehouse_fail: AnalyticsGlobalProps & {
        order_id: number;
        error_code: string;
        error_message: string;
        http_status: number;
        warehouse_id?: number;
    };

    order_reserve_for_agenda_click: AnalyticsGlobalProps & {
        order_id: number;
        appointment_id?: number;
        service_id?: number;
        items_count?: number;
    };

    order_reserve_for_agenda_success: AnalyticsGlobalProps & {
        order_id: number;
        appointment_id?: number;
        service_id?: number;
        items_count?: number;
    };

    order_reserve_for_agenda_fail: AnalyticsGlobalProps & {
        order_id: number;
        error_code: string;
        error_message: string;
        http_status: number;
        appointment_id?: number;
    };

    // ===== PRICING =====
    pricing_view: AnalyticsGlobalProps & {};

    pricing_rule_add_click: AnalyticsGlobalProps & {
        rule_type: PricingRuleType;
        scope?: string;
        value?: number;
    };

    pricing_rule_add_success: AnalyticsGlobalProps & {
        rule_type: PricingRuleType;
        scope?: string;
        value?: number;
    };

    pricing_rule_add_fail: AnalyticsGlobalProps & {
        rule_type: PricingRuleType;
        error_code: string;
        error_message: string;
        http_status: number;
        scope?: string;
    };

    // ===== SUPPLIERS =====
    suppliers_view: AnalyticsGlobalProps & {};

    supplier_add_click: AnalyticsGlobalProps & {
        supplier_type?: string;
        has_integration?: boolean;
    };

    supplier_add_success: AnalyticsGlobalProps & {
        supplier_id: number;
        supplier_type?: string;
        has_integration?: boolean;
    };

    supplier_add_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        supplier_type?: string;
    };

    // ===== CUSTOMERS =====
    customers_view: AnalyticsGlobalProps & {};

    customer_create_click: AnalyticsGlobalProps & {
        customer_type?: string;
        has_vehicle_link?: boolean;
    };

    customer_create_success: AnalyticsGlobalProps & {
        customer_id: number;
        customer_type?: string;
        has_vehicle_link?: boolean;
    };

    customer_create_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        customer_type?: string;
    };

    // ===== VEHICLES =====
    vehicles_view: AnalyticsGlobalProps & {};

    vehicle_create_click: AnalyticsGlobalProps & {
        plate_provided?: boolean;
        vin_provided?: boolean;
        linked_customer?: boolean;
    };

    vehicle_create_success: AnalyticsGlobalProps & {
        vehicle_id: number;
        plate_provided?: boolean;
        vin_provided?: boolean;
        linked_customer?: boolean;
    };

    vehicle_create_fail: AnalyticsGlobalProps & {
        error_code: string;
        error_message: string;
        http_status: number;
        plate_provided?: boolean;
        linked_customer?: boolean;
    };

    // ===== REPORTS =====
    reports_view: AnalyticsGlobalProps & {};

    reports_tab_click: AnalyticsGlobalProps & {
        tab_name: ReportsTab;
    };

    // ===== SETTINGS =====
    settings_view: AnalyticsGlobalProps & {};

    settings_section_view: AnalyticsGlobalProps & {
        section: SettingsSection;
    };
}